import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { Form, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/Login.css";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // reject if required fields are blank
    if (!identifier || !password) {
      toast.error("Please provide username/email and password");
      return;
    }

    try {
      setIsLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/auth`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ identifier, password }),
        },
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Login failed");
      }

      toast.success("Login successful");

      // redirect after login
      await refreshUser();
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login__container">
      <div className="login__form--container">
        <h1>Sign In</h1>

        <Form onSubmit={submitHandler}>
          <Form.Group className="my-3" controlId="identifier">
            <Form.Label>Email or Username</Form.Label>
            <Form.Control
              className="login__form--input"
              type="text"
              placeholder="Enter email or username"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="my-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <div className="login__form--password-input">
              <Form.Control
                className="login__form--input"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="button"
                className="login__form-password--toggle"
                variant="outline-secondary"
                onClick={handleTogglePassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </div>
          </Form.Group>

          <Button disabled={isLoading} type="submit" variant="primary">
            Sign In
          </Button>

          {isLoading && <Loader />}
        </Form>
      </div>
    </div>
  );
}
